import { PlusIcon } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import {
  BankAccountsTable,
  InvoicingBankAccount,
  useBankAccountDialogs,
} from '@/containers/Settings/BankAccounts/BankAccounts'

import { EditableZone } from './EditableZone'

export interface InvoicingPreviewBankAccountsProps {
  bankAccounts: InvoicingBankAccount[]
  onMutate: () => void
  children: React.ReactNode
}

export const InvoicingPreviewBankAccounts = ({
  bankAccounts,
  onMutate,
  children,
}: InvoicingPreviewBankAccountsProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'settings' })
  const { t: tb } = useTranslation(undefined, {
    keyPrefix: 'settings.bankAccounts',
  })

  const [open, setOpen] = useState(false)
  const { openCreate, openEdit, askDelete, dialogs } = useBankAccountDialogs(onMutate)

  const createButton = (
    <Button onClick={openCreate} size="sm" variant="outline">
      <PlusIcon />
      {tb('actions.create')}
    </Button>
  )

  return (
    <>
      <EditableZone
        onClick={() => setOpen(true)}
        ariaLabel={t('invoicing.preview.bankAccounts.title')}
        className="inline-block w-auto p-1"
      >
        {children}
      </EditableZone>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-xl">
          <DialogHeader>
            <DialogTitle>{t('invoicing.preview.bankAccounts.title')}</DialogTitle>
            <DialogDescription>
              Na doklad se vytiskne výchozí účet.
            </DialogDescription>
          </DialogHeader>

          <BankAccountsTable
            compact
            bankAccounts={bankAccounts}
            onEdit={openEdit}
            onDelete={askDelete}
            emptyAction={createButton}
          />

          {bankAccounts.length > 0 && <div className="flex justify-end">{createButton}</div>}
        </DialogContent>
      </Dialog>

      {dialogs}
    </>
  )
}
